import { styled, gapStyle, borderStyle, normaliseColor } from 'mb-components';

export type GroupListProps = {};

export const GroupListItem = styled.div<GroupListProps>`
  width: 100%;
  ${gapStyle('padding', {
    vertical: '3',
  })}
  ${borderStyle({
    side: 'bottom',
    color: 'gray-400',
  })}

  &:first-of-type {
    padding-top: 0;
  }

  &:last-of-type {
    padding-bottom: 0;
    border-bottom: 0;
  }

  a {
    display: block;

    &:hover {
      color: ${normaliseColor('pink-500')};
    }
  }
`;
